module.exports = __webpack_public_path__ + "static/media/icon.uncheck.bfe52bc2.svg";